module.exports = __webpack_public_path__ + "img/download.2e0cdb24.png";